// Audio slots for Founders' thank-you messages.
//
// One entry per founder — keyed by the same `id` used in
// `FoundersSection.jsx`. Leave the value at `null` while the recording
// is still pending. When the audio is ready, paste the direct URL
// (Emergent Object Storage, Bunny CDN, or any HTTPS mp3/m4a source)
// as a string and the FounderAudioButton will pick it up automatically
// on the next reload — no code changes needed.
//
// Accepted values:
//   • null                     → renders the disabled "coming soon" pill
//   • "https://…/tayeb.mp3"    → renders the interactive audio player
//
// Recommended format: mp3 or m4a, 128–192 kbps, mono, 30–120 s. Keep
// filenames all-lowercase, no spaces, no accents.

export const FOUNDER_AUDIO = {
  // Temporary placeholder — same file for both founders until each
  // founder records their own thank-you message. Replace either entry
  // with the founder-specific URL when ready.
  "tayeb-ettaiek": "https://customer-assets-m6fa6gv7.emergentagent.net/job_c24999ff-c14f-412e-baf4-b11c0020fcc2/artifacts/v710s7s3_Grup%20Xaluca.mp3",
  "lluis-pont":    "https://customer-assets-m6fa6gv7.emergentagent.net/job_c24999ff-c14f-412e-baf4-b11c0020fcc2/artifacts/v710s7s3_Grup%20Xaluca.mp3",
};;

export const getFounderAudioSrc = (founderId) => {
  const src = FOUNDER_AUDIO[founderId];
  return typeof src === "string" && src.trim().length > 0 ? src.trim() : null;
};
